<template>
  <section class="el-transfer transfer">
    <div class="el-transfer-panel">
      <p class="el-transfer-panel__header">
        <el-input v-model="keyword" placeholder="请输入关键字搜索数据" size="mini" class="search-input" @input.native="handleInput" @keyup.enter.native="searchUsers">
          <i slot="suffix" class="el-icon-search" @click="searchUsers" />
        </el-input>
      </p>
      <ul class="el-transfer-panel__body">
        <li
          v-for="(item, idx) in list"
          :key="item[idKey]"
          :class="`transfer-item ${item.disabled && 'disabled'}`"
          @click="!disabled && handleAddCheck(idx)"
        ><span>{{ item.name }}</span><i class="el-icon-circle-plus" /></li>
        <li v-if="!list.length" style="text-align: center">没有数据</li>
      </ul>
      <div class="footer" />
    </div>
    <div class="el-transfer-panel">
      <p class="el-transfer-panel__header">选中的数据</p>
      <ul class="el-transfer-panel__body">
        <li
          v-for="(user, idx) in checked"
          :key="user.id"
          class="transfer-item"
          @click="!disabled && handleRemoveChecked(idx)"
        ><span>{{ user.name }}</span><i class="el-icon-remove" /></li>
        <li v-if="!checked.length" style="text-align: center">没有数据</li>
      </ul>
      <div class="footer" />
    </div>
  </section>
</template>

<script>


export default {
  name: 'index',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    list: { type: Array, default: Array },
    valueKey: { type: String, default: 'name' },
    idKey: { type: String, default: 'id' },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      users: [],
      checked: [],
      keyword: ''
    }
  },
  created() {
    
  },
  methods: {
    handleAddCheck(){

    },
    handleRemoveChecked() {

    },
    searchUsers(callback) {

    },
     handleInput() {
      if (!this.keyword) this.searchUsers()
    }
  }
}
</script>

<style lang="less" scoped>

  .transfer {
    li {
      transition: background-color .1s ease-in-out;
      &:hover {
        background-color: #f5f7fa;
      }
    }
    .el-transfer-panel {
      margin-right: 20px;
      .el-transfer-panel__header {
        padding: 0 15px;
      }
    }
  }
</style>
